// src/services/userService.js
import http from './http';
import { wOrgIdMiddleware } from '../utils/commonUtils';
import { CREATED, OK } from '../utils/constant';
// import { useDispatch } from 'react-redux';
// import {setProfileDetails} from '../store/ProfileSlice';

const PatientChartsService = {

  getPatientChart: wOrgIdMiddleware(async (url, companyuuid, activityMappingId) => {
    try {
      const response = await http.GET(`${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/activity-charts`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      // console.error('Error fetching company:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  }),
  //Save save PatientCharts 
  savePatientCharts: wOrgIdMiddleware(async (url = '', companyuuid, activityMappingId, data) => {
    try {
      // Check if data is FormData (for file uploads)
      const isFormData = data instanceof FormData;
      const headers = isFormData ? { 'Content-Type': 'multipart/form-data' } : undefined;
      // Use POSTwithoutAES for FormData, regular POST for JSON
      const response = isFormData 
        ? await http.POSTwithoutAES(`${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/activity-charts`, data, headers)
        : await http.POST(`${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/activity-charts`, data);
      if ((response.code === OK || response.code === CREATED) && response.data) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  }, true),
  // Update 
  updatePatientCharts: wOrgIdMiddleware(async (url = '', companyuuid, activityMappingId, data) => {
    try {
      // Check if data is FormData (for file uploads)
      const isFormData = data instanceof FormData;
      const headers = isFormData ? { 'Content-Type': 'multipart/form-data' } : undefined;
      if (isFormData) {
        data.append('_method', 'PUT');
        const response = await http.POSTwithoutAES(`${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/activity-charts`, data, headers);
        if ((response.code === OK || response.code === CREATED) && response.data) {
          return response.data;
        } else {
          return response;
        }
      } else {
        // Regular PUT for JSON data
        const response = await http.PUT(`${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/activity-charts`, data);
        if ((response.code === OK || response.code === CREATED) && response.data) {
          return response.data;
        } else {
          return response;
        }
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  }, true),
  getPrintLabel: wOrgIdMiddleware(async (url, query = {}, visitMappingId) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-visit-label/${visitMappingId}?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),

  getPrintConsent: wOrgIdMiddleware(async (url, query = {}, visitId) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-visit-consent-pdf/${visitId}?${queryString}`);
      console.log('response',response);
      if (response.code === OK) {
        return response.data;
      }else{
        return null;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return null;
        }
        else{
          return null;
        }
      }

      throw error;
    }
  }, true),

  submitDotNow: wOrgIdMiddleware(async (url, activityMappingId, visitId) => {
    try {
      const response = await http.POST(
        `${url}visit-activity-mappings/${activityMappingId}/visit-id/${visitId}/dot-submit-now`,
        { visit_id: visitId }
      );
      return response.data || response;
    } catch (error) {
      if (error && error.data) {
        return error.data;
      }
      throw error;
    }
  }),
  scheduleDotNightly: wOrgIdMiddleware(async (url, activityMappingId, visitId) => {
    try {
      const response = await http.POST(
        `${url}visit-activity-mappings/${activityMappingId}/visit-id/${visitId}/dot-schedule-nightly`,
        { visit_id: visitId }
      );
      return response.data || response;
    } catch (error) {
      if (error && error.data) {
        return error.data;
      }
      throw error;
    }
  }),
  // Get DOT scheduler status for a given mapping
  getDotSchedulerStatus: wOrgIdMiddleware(async (url, companyuuid, activityMappingId) => {
    try {
      const response = await http.GET(
        `${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/dot-scheduler-status`
      );
      return response.data || response;
    } catch (error) {
      if (error && error.data) {
        return error.data;
      }
      throw error;
    }
  }, true),
  // Get DOT form event logs
  getDotFormEventLogs: wOrgIdMiddleware(async (url, companyuuid, activityMappingId) => {
    try {
      const response = await http.GET(
        `${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/dot-form-event-logs`
      );
      if (response.code === OK && response.data) {
        // Handle both encrypted and non-encrypted responses
        const data = response.data.data || response.data;
        if (Array.isArray(data)) {
          return data;
        }
        if (data && data.success && Array.isArray(data.data)) {
          return data.data;
        }
      }
      return [];
    } catch (error) {
      console.error('Error fetching DOT form event logs:', error);
      return [];
    }
  }, true),
  // Get DOT submission logs grouped by visit (can be called without org ID for global admin)
  // filters: { employee_id, visit_from, visit_to, page, per_page, sort_order }
  // Returns { data: [], total_records: number }
  getDotSubmissionLogs: async (orgId = null, filters = {}) => {
    try {
      let apiUrl;
      if (orgId) {
        apiUrl = `organizations/${orgId}/dot-submission-logs`;
      } else {
        // For global admin, call without organization prefix
        apiUrl = `dot-submission-logs`;
      }
      const params = new URLSearchParams();
      if (filters.employee_id) params.append('employee_id', filters.employee_id);
      if (filters.visit_from) params.append('visit_from', filters.visit_from);
      if (filters.visit_to) params.append('visit_to', filters.visit_to);
      if (filters.page) params.append('page', filters.page);
      if (filters.per_page) params.append('per_page', filters.per_page);
      if (filters.sort_order) params.append('sort_order', filters.sort_order);
      const queryString = params.toString();
      if (queryString) apiUrl += `?${queryString}`;
      const response = await http.GET(apiUrl);
      if (response.code === OK && response.data) {
        const res = response.data;
        const data = res.data ?? res;
        const totalRecords = res.total_records ?? (Array.isArray(data) ? data.length : 0);
        if (Array.isArray(data)) {
          return { data, total_records: totalRecords };
        }
      }
      return { data: [], total_records: 0 };
    } catch (error) {
      console.error('Error fetching DOT submission logs:', error);
      console.error('Error response:', error.response);
      console.error('Error message:', error.message);
      return { data: [], total_records: 0 };
    }
  },
  getPrintChartNote: wOrgIdMiddleware(async (url, visitId) => {
    try {
      // Use the real chart note endpoint: chart-note/PRINT_CHART
      // This returns a base64-encoded PDF from getAllProgressNote()
      console.log('visitIddddddddd',visitId);
      const response = await http.GET(`${url}${visitId}/chart-note/PRINT_CHART`);
      if (response.code === OK || response.code === 200) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching chart note PDF:', error);
      return null;
    }
  }),
  getPrintEditedChartNote: wOrgIdMiddleware(async (url, visitId) => {
    try {
      // Use the edited chart note endpoint: get-chart-note/print_chartnote
      // This returns a base64-encoded PDF from the edited chart note
      const response = await http.GET(`${url}${visitId}/get-chart-note/print_chartnote`);
      if (response.code === OK || response.code === 200) {
        return response.data;   // base64 PDF
      }
      return null;
    } catch (error) {
      console.error('Error fetching edited chart note PDF:', error);
      return null;
    }
  }),
  getPrintResult: wOrgIdMiddleware(async (url, query = {}, mappingId) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-results-pdf/${mappingId}?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  getProviderResult: wOrgIdMiddleware(async (url, query = {}, mappingId) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-provider-pdf/${mappingId}?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),

  getPatientResult: wOrgIdMiddleware(async (url, query = {}, mappingId) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-history-pdf/${mappingId}?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  getLaboratoryReport: wOrgIdMiddleware(async (url, query = {}, visitLabId) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-laboratory-report/${visitLabId}?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  getLabRequisition: wOrgIdMiddleware(async (url, query = {}, visitLabId) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-laboratory-requisition/${visitLabId}?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  sendLabResults: wOrgIdMiddleware(async (url, payload) => {
    try {
      const response = await http.POST(`${url}send-lab-results`, payload);
      if (response.code === OK || response.code === CREATED) {
        return response.data;
      }
      const errMsg = response.data?.error || (typeof response.data === 'string' ? response.data : null) || response.message || 'Failed to send lab results';
      throw new Error(errMsg);
    } catch (error) {
      if (error?.data?.error) {
        throw new Error(error.data.error);
      }
      if (error?.data?.message) {
        throw new Error(error.data.message);
      }
      if (error?.message) {
        throw error;
      }
      throw new Error('Failed to send lab results');
    }
  }, true),
  //Save user
  saveActivityConsentCharts: wOrgIdMiddleware(async (url = '', companyuuid, activityMappingId, data) => {
    try {
      const response = await http.POST(`${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/activity-consent`, data)
      if ((response.code === OK || response.code === CREATED) && response.data) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  }, true),
  updateActivityConsentCharts: wOrgIdMiddleware(async (url = '', companyuuid, activityMappingId, data) => {
    try {
      const response = await http.PUT(`${url}companies/${companyuuid}/visit-activity-mappings/${activityMappingId}/activity-consent`, data)
      if ((response.code === OK || response.code === CREATED) && response.data) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  }, true),
  getClearanceReportPDF: wOrgIdMiddleware(async (url = '', visit_id) => {
    // console.log(visit_id, url);
    try {
      const response = await http.GET(`${url}clearance-report/${visit_id}`);
      if (response.code === OK) {
        return response.data;
      }else{
        return null;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  getMedicalExaminationReportPDFData: wOrgIdMiddleware(async (url = '', mapping_id) => {

    try {
      const response = await http.GET(`${url}get-medical-examination-report-pdf/${mapping_id}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  getMedicalExaminerCertificatePDFData: wOrgIdMiddleware(async (url = '', mapping_id) => {

     try {
       const response = await http.GET(`${url}get-medical-examiner-certificate/${mapping_id}`);
       if (response.code === OK) {
         return response.data;
       }
     } catch (error) {
       console.error('Error fetching user:', error);
       if (error.status) {
         const resData = error.data;
         if (resData.code && resData.data) {
           return resData;
         }
       }
 
       throw error;
     }
   }, true),
  getVaccinationResult: wOrgIdMiddleware(async (url = '', query = {}) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}vaccines-list?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  getVaccinePDF: wOrgIdMiddleware(async (url = '', id) => {
    try {
      const response = await http.GET(`${url}get-vaccine-pdf/${id}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  
  getInjectionPDF: wOrgIdMiddleware(async (url = '', id) => {
    try {
      const response = await http.GET(`${url}get-injection-pdf/${id}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching injection PDF:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  
  getVaccineResultReport: wOrgIdMiddleware(async (url = '', query = {}, vaccineId) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-vaccine-result-report/${vaccineId}?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching vaccine result report:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  getChildLabOrders: wOrgIdMiddleware(async (url = '', parent_lab_id) => {
    try {
      const response = await http.GET(`${url}childlaborders/parent/${parent_lab_id}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }),
  saveChildLabOrders: wOrgIdMiddleware(async (url = '', formdata = {}) => {
    const response = await http.POST(`${url}childlaborders/`, formdata);
    return response;
  }),
  updateChildLabOrders: wOrgIdMiddleware(async (url = '', id, formdata = {}) => {
    const response = await http.PUT(`${url}childlaborders/${id}`, formdata);
    return response;
  }),
  deleteChildLabOrders: wOrgIdMiddleware(async (url = '',id) => {
    const response = await http.DELETE(`${url}childlaborders/${id}`);
    return response;
  }),
  getWorkStatusResult: wOrgIdMiddleware(async (url = '', query = {}) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-all-work-status-forms?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  sendBulkWorkStatusFormEmailToEmployer: wOrgIdMiddleware(async (url = '', payload = {}) => {
    const response = await http.POST(`${url}send-bulk-work-status-form-email-to-employer`, payload);
    return response;
  }),
  getWorkStatusPDF : wOrgIdMiddleware(async (url = '', id) => {
    try {
      const response = await http.GET(`${url}get-workstatus-pdf/${id}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  sendWorkStatusSMSEmailResult:wOrgIdMiddleware(async (url = '', id) => {
    try {
      const response = await http.GET(`${url}send-workstatus-pdf/${id}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  bulkSendWorkStatusSMSEmailResult: wOrgIdMiddleware(async (url = '', selectedIds) => {
    try {
      const payload = {
        selectedIds: selectedIds
      };
      const response = await http.POST(`${url}bulk-send-workstatus-pdf`, payload);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error bulk sending work status SMS & Email:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),
  deleteWorkStatus: wOrgIdMiddleware(async (url = '', id) => {
    try {
      const response = await http.DELETE(`${url}work-status/${id}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      console.error('Error deleting work status:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      throw error;
    }
  }, true),

};

export default PatientChartsService;